// extracted by css-extract-rspack-plugin
export default {"cls1":"Thumbnail-cls1_VaK","cls2":"Thumbnail-cls2_hMG Thumbnail-cls1_VaK"};